<template>
    <Head>
        <title>Аналитика транзакций</title>
    </Head>

    <authenticated-layout :notifications="notifications" >
        <template #header>
            <v-navigation :organization-id="organizationId"/>
        </template>

        <div class="bg-white mb-6">
            <form
                class="grid grid-cols-7 items-end gap-4 p-6"
                method="post"
                :action="routes.unload"
                @submit.prevent="form.post(routes.unload)"
            >
                <v-select label="Период" v-model="form.period" :error="errors.period">
                    <option value="day">день</option>
                    <option value="week">неделя</option>
                    <option value="month">месяц</option>
                </v-select>
                <v-input label="Дата начала" type="date" v-model="form.startDate" :error="errors.startDate" />
                <v-input label="Дата окончания" type="date" v-model="form.endDate" :error="errors.endDate" />
                <v-button color="green" type="button" @click="update">Обновить</v-button>
                <div></div>
                <v-select label="Группировка" v-model="form.group" :error="errors.group">
                    <option value="period">по периоду</option>
                    <option value="type">по типу</option>
                    <option value="currency">по валюте</option>
                    <option value="network">по сети</option>
                </v-select>
                <v-button color="blue">Выгрузить</v-button>
            </form>
        </div>



        <div class="bg-white">
            <div class="grid grid-cols-11 gap-2 p-2 text-sm font-bold items-end">
                <span class="row-span-2"></span>
                <span class="row-span-2 text-center">Начало<br/>периода</span>
                <span class="col-span-4 text-center bg-gray-100">IN</span>
                <span class="col-span-5 text-center bg-gray-200">OUT</span>

                <span class="text-right">Кол-во</span>
                <span class="col-span-2 text-right">Сумма</span>
                <span class="text-right">Комиссия<br/>сервиса</span>

                <span class="text-right">Кол-во</span>
                <span class="col-span-2 text-right">Сумма</span>
                <span class="text-right">Комиссия<br/>сервиса</span>
                <span class="text-right">Комиссия<br/>блокчейна</span>
            </div>

            <div class="grid grid-cols-11 items-center gap-2 p-2 border-t" v-for="r in result">
                <div @click="r.showTypes = !r.showTypes" class="cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current text-gray-500" viewBox="0 0 16 16">
                        <path v-if="r.showTypes || false" d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                        <path v-else d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                </div>
                <div class="text-center">{{ moment(r.periodStartDate).utc().format('L') }}</div>
                <div class="text-right">{{ r.in_number }}</div>
                <div class="col-span-2 text-right">{{ r.in_amount_usd }} $</div>
                <div class="text-right">{{ r.in_service_commission_usd }} $</div>
                <div class="text-right">{{ r.out_number }}</div>
                <div class="col-span-2 text-right">{{ r.out_amount_usd }} $</div>
                <div class="text-right">{{ r.out_service_commission_usd }} $</div>
                <div class="text-right">{{ r.out_blockchain_commission_usd }} $</div>

                <div v-show="r.showTypes || false" class="col-span-full bg-gray-50 rounded">
                    <div class="grid grid-cols-11 gap-2 items-center" v-for="t in r.types">
                        <div @click="t.showCurrencies = !t.showCurrencies" class="pl-6 cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current text-gray-500" viewBox="0 0 16 16">
                                <path v-if="t.showCurrencies || false" d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                <path v-else d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                            </svg>
                        </div>
                        <div class="pl-6 flex flex-col">
                            <v-label>Тип</v-label>
                            <span>{{ t.type }}</span>
                        </div>
                        <div class="text-right">{{ t.in_number }}</div>
                        <div class="col-span-2 text-right">{{ t.in_amount_usd }} $</div>
                        <div class="text-right">{{ t.in_service_commission_usd }} $</div>
                        <div class="text-right">{{ t.out_number }}</div>
                        <div class="col-span-2 text-right">{{ t.out_amount_usd }} $</div>
                        <div class="text-right">{{ t.out_service_commission_usd }} $</div>
                        <div class="text-right">{{ t.out_blockchain_commission_usd }} $</div>

                        <div v-show="t.showCurrencies || false" class="col-span-full bg-gray-100 rounded">
                            <div class="grid grid-cols-11 gap-2 items-center" v-for="c in t.currencies">
                                <div @click="c.showNetworks = !c.showNetworks" class="pl-12 cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current text-gray-500" viewBox="0 0 16 16">
                                        <path v-if="c.showNetworks || false" d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                        <path v-else d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                    </svg>
                                </div>
                                <div class="pl-12 flex flex-col">
                                    <v-label>Валюта</v-label>
                                    <span>{{ c.currency }}</span>
                                </div>
                                <div class="text-right">{{ c.in_number }}</div>
                                <div class="col-span-2 text-right">{{ c.in_amount_usd }} $</div>
                                <div class="text-right">{{ c.in_service_commission_usd }} $</div>
                                <div class="text-right">{{ c.out_number }}</div>
                                <div class="col-span-2 text-right">{{ c.out_amount_usd }} $</div>
                                <div class="text-right">{{ c.out_service_commission_usd }} $</div>
                                <div class="text-right">{{ c.out_blockchain_commission_usd }} $</div>


                                <div v-show="c.showNetworks || false" class="col-span-full bg-gray-200 rounded">
                                    <div class="grid grid-cols-11 gap-2 items-center" v-for="n in c.rows">
                                        <div class="col-start-2 pl-16 flex flex-col">
                                            <v-label>Сеть</v-label>
                                            <span>{{ n.network }}</span>
                                        </div>
                                        <div class="text-right">{{ n.in_number }}</div>
                                        <div class="col-span-2 flex flex-col text-right">
                                            <span>{{ n.in_amount_usd }} $</span>
                                            <v-label>{{ n.in_amount }} {{ c.currency }}</v-label>
                                        </div>
                                        <div class="text-right">{{ n.in_service_commission_usd }} $</div>
                                        <div class="text-right">{{ n.out_number }}</div>
                                        <div class="col-span-2 flex flex-col text-right">
                                            <span>{{ n.out_amount_usd }} $</span>
                                            <v-label>{{ n.out_amount }} {{ c.currency }}</v-label>
                                        </div>
                                        <div class="text-right">{{ n.out_service_commission_usd }} $</div>
                                        <div class="flex flex-col text-right">
                                            <span>{{ n.out_blockchain_commission_usd }} $</span>
                                            <v-label>{{ n.out_blockchain_commission }} {{ n.out_blockchain_currency || c.currency }}</v-label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>

    </authenticated-layout>
</template>

<script>

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Organization';
import VLabel from '@/Components/Label';
import VInput from '@/Components/Input';
import VSelect from '@/Components/Select';
import VButton from '@/Components/Button';
import moment from "moment";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VLabel,
        VInput,
        VSelect,
        VButton,
    },
    props: {
        organizationId: String,
        success: Boolean,
        notifications: Array,
        errors: Object,
        result: Object,
        dataInput: Object,
    },
    data() {
        return {
            routes: {
                unload:this.route('transactions.analytics.unload'),
                update: this.route('organization.analytics', this.organizationId),
            },
            form: useForm({
                organizationId: this.organizationId,
                period: this.dataInput.period,
                group: 'period',
                startDate: this.dataInput.startDate,
                endDate: this.dataInput.endDate,
            })
        }
    },
    methods: {
        moment,
        update() {
            const {period, startDate, endDate} = this.form;
            useForm({period, startDate, endDate}).get(this.routes.update)
        }
    },

};
</script>
